<template>
  <div class="home-container">
    <h2 class="content-block">Device Settings and Configuration</h2>

    <div class="content-block">
      <DxTabs :items="tabs" selection-mode="single" v-model:selected-index="tabSelectedIx" />

      <!-- My Account -->
      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==0)">
        <AccountEditor />
      </div>

      <!-- Team -->
      <div class="dx-card responsive-paddings" v-if="tabSelectedIx==1">
        <div :class="{'warning-icon':(!isMyUserAdmin)}" />
        <div :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}">
          <div class="row-3">
            <DxButton
              text="Create new user"
              type="success"
              style=""
              hint="To add a user and set privileges click the button and fill the required information, use the list to manage users accounts"
              @click="showAddUserForm"
              />
          </div>
          <!--<p style="padding-right:20px">To add a user and set privileges click the button and fill the required information, use the list to manage users accounts</p>-->
        
          <div class="row">
            <DxDataGrid :data-source="orgUsersDataSource" :column-min-width="30" :column-hiding-enabled="true">
              <DxColumn  :width="30" cell-template="chart-cell-template"></DxColumn>   
              <template #chart-cell-template="{ data }" >
                  <div
                    id="circle"
                    v-if="(data.data.username==currentUser)"
                  ></div>
              </template>    
              <DxColumn data-field="username" caption="Login Name" :width="140"></DxColumn>
              <DxColumn data-field="name" :hiding-priority="2"></DxColumn>
              <DxColumn data-field="lastName" :hiding-priority="1"></DxColumn>
              <DxColumn data-field="email" :hiding-priority="0"></DxColumn>
              <DxSearchPanel :visible="true" />
              <DxSelection mode="single"/>
              <DxMasterDetail
                :enabled="true"
                :auto-expand-all="false"
                template="userTeamDetailsTmplt"
              />
            
              <template #userTeamDetailsTmplt="{ data: user }">
                <UsersSettingsDetail :template-data="user" @user-update="refreshUserList"/>
              </template>
            </DxDataGrid>
          </div>
        </div>
      </div>


      <!-- SITE -->
      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==2)">
        <SiteEditor />
      </div>

      <!-- Buses and Nodes -->
      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==3)">
        <BusesNodesEditor />
      </div>


      <!-- EMS -->
      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==4)">
        <EmsEditor/>
      </div>

      <!-- ASSETS -->

      <div class="dx-card responsive-paddings" v-if="tabSelectedIx==5">
        <div :class="{'warning-icon':(!isMyUserAdmin)}" />
        <div :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}">
          <div class="col-sm-10 col-md-4 col-lg-3">
            <div class="row">
              <div class="col-12"><DxButton text="create new asset" width="100%" type="success" @click="showAddAssetForm" /></div>
            </div>
            <div class="row">
              <div class="col-12"><DxButton text="remove asset" width="100%" type="danger" @click="showConfirmationMessage_as" /></div>
            </div> 
            <div class="row mt-1">
              <!--<DxTreeView  
                ref="deviceTree"
                :data-source="deviceTreeDS"
                data-structure="plain"
                selection-mode="single"
                :select-by-click="true"
                @item-click="treeSelectionChange" />-->

                <DxTreeList
                  id = "deviceTree"
                  ref="deviceTree"
                  :data-source="deviceTreeDS"
                  :show-column-headers="false"
                  :show-borders="false"
                  :show-row-lines="false"
                  :show-column-line="false"
                  key-expr="id"
                  parent-id-expr="parentId"
                  @row-click="treeSelectionChange"
                >
                <DxSelectionTree mode="single" />
                <DxFilterRow :visible="true"/>
                   
                <DxColumnTree
                  :width="200"
                  data-field="text"
                  caption="Asset List"
                  :allow-search="true"
                >
                  
                </DxColumnTree>
              </DxTreeList>

            </div>
          </div>
          <div class="col-sm-12 col-md-8 col-lg-9">
            <div v-if="(devConfigView=='empty')" class="position-relative" style="height: 25vh; min-height: 100px;">
              <div class="position-absolute top-50 start-50 translate-middle">
                <h3 class="text-center">Select an item from the list to view and edit its configuration</h3>
              </div>
            </div>
            <!--<CommandEditor ref="signalView" :signalId="devViewId" v-if="(devConfigView=='command')||(devConfigView=='assetCommand')" />  -->
            <SignalEditor ref="signalView" :signalId="devViewId" v-if="(devConfigView=='signal')" />  
            <AssetEditor ref="assetView" :name="devViewId" v-if="(devConfigView=='asset')||(devConfigView=='assetSignal')" @asset-update="updateAssetTree" @signal_selected="signalSelection"/> 
          </div>
        </div>
      </div>


      <!-- CONTROLLERS -->

      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==6)">
        <ControllerEditor />
      </div>
      
      <!-- Modules and services -->

      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==7)">
        <ServicesEditor />
      </div>

      
      <!-- Contracts -->   

      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==8)" style="padding-top:1rem">
        <ContractsEditor />
      </div>

     <!-- WIFI settings -->

      <div class="dx-card responsive-paddings" v-if="(tabSelectedIx==9)">
        <NetworkEditor />
      </div>


    </div>
      
     
    <DxPopup
      content-template="confirm-delete-asset"
      :show-title="false"
      max-width="320px"
      max-height="100px"
      :show-close-button="false"
      v-model:visible="isShownConfirmationMessage_as"
      :hide-on-outside-click="false">
      <template #confirm-delete-asset>
        <p style="text-align: center;">Are you sure you want to delete this asset?</p>
          <div class="row mt-1">
          <div class="col"><DxButton text="Yes" @click="deleteSelectedAsset" type="normal" width="100%" height="30px" /></div>
          <div class="col"><DxButton text="No" @click="hideConfirmationMessage_as" type="danger" width="100%" height="30px"/></div>
        </div>
      </template>            
    </DxPopup>


    <DxPopup
      content-template="add-user-form"
      title="Create a New User"
      max-width="480px"
      max-height="600px"
      :show-close-button="true"
      v-model:visible="isAddUserFormVisible"
      :hide-on-outside-click="true">
      <template #add-user-form>
        <DxScrollView width="100%" height="100%" >
          <AddLocalUserForm @user-update="refreshUserList"/>
        </DxScrollView>
      </template>            
    </DxPopup>

    <DxPopup
      content-template="add-asset-form"
      title="Create a New Asset"
      max-width="400px"
      max-height="360px"
      :show-close-button="true"
      v-model:visible="isAddAssetFormVisible"
      :hide-on-outside-click="true">
      <template #add-asset-form>
        <DxScrollView width="100%" height="100%" >
          <AddAssetForm @cancel="hideAddAssetForm" @asset-update="()=>{hideAddAssetForm(); refreshDeviceTree();}" />
        </DxScrollView>
      </template>            
    </DxPopup>

    

  </div>
</template>

<script>
import RawDataService from '../services/RawDataServiceTemplate';
import DataService from '../services/DataServiceTemplate';
import DxButton from 'devextreme-vue/button';
import {computed, ref, reactive } from 'vue';
import { useStore } from 'vuex';

import { 
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxSearchPanel,
  DxMasterDetail,
} from 'devextreme-vue/data-grid';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import {
  DxTreeList,
  DxSelection as DxSelectionTree,
  DxColumn as DxColumnTree,
  DxFilterRow,
} from 'devextreme-vue/tree-list';
import DxTabs from "devextreme-vue/tabs";
import notify from 'devextreme/ui/notify';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";


import UsersSettingsDetail from '../components/settings-user-teams.vue';
import AddLocalUserForm from '../components/settings-create-user.vue';
import AddAssetForm from '../components/settings-create-asset.vue';

import SignalEditor from '../components/settings-signals.vue';
//import CommandEditor from '../components/settings-commands.vue';
import AssetEditor from '../components/settings-assets.vue';
import ControllerEditor from '../components/settings-controllers.vue';
import BusesNodesEditor from '../components/settings-BusesNodes.vue';
import ServicesEditor from '../components/settings-services.vue';
import SiteEditor from '../components/settings-site.vue';
import NetworkEditor from '../components/settings-networks.vue';
import ContractsEditor from '../components/contracts-app.vue';
import AccountEditor from '../components/profile-page.vue';
import EmsEditor from '../components/settings-ems.vue';

export default {
  components: {
    DxTabs,
    DxButton,
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxSearchPanel,
    DxPopup,
    DxScrollView,
   
    DxTreeList,
    DxColumnTree,
    DxSelectionTree,
    DxFilterRow,

    DxMasterDetail,
    UsersSettingsDetail,
    AddLocalUserForm,
    
    AddAssetForm,
    SignalEditor,
    //CommandEditor,
    AssetEditor,
    ControllerEditor,
    BusesNodesEditor,
    ServicesEditor,
    SiteEditor,
    NetworkEditor,
    ContractsEditor,
    AccountEditor,
    EmsEditor,
  },
  data(){
    return{
    }
  },
  setup() {
    // Validate permissions
    const store = useStore()
    const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
    const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)
    //

    const tabs = ref([
      { text: "My Account", icon: 'card' },
      { text: "Local Users", icon: 'group' },
      { text: "Site Layout", icon: 'toolbox' },
      { text: "Buses & Nodes", icon: 'pin' },
      { text: "EMS", icon: 'box' },
      { text: "Assets & Signals", icon: 'preferences' },
      { text: "Controllers", icon: 'variable' },
      { text: "Modules & Services", icon: 'info' },
      { text: "Contracts", icon: 'folder' },
      { text: "System", icon: 'globe' },
      
    ]);
    const deviceTree = ref(null);
    const tabSelectedIx = ref(0);
    const userInviteForm = reactive({email: null});
    const isCreateOrgVisible = ref(false);
    const newOrgInfo = reactive({
      name:'',
      description:'',
      address:'',
      city:'',
      country:'Spain',
    });

    const devInfo = reactive(
      { 
        uid: 'null', 
        serialNumber: '', 
        name: 'loading dev data' 
      })

  
    const userStore = computed(() => store.state.user);
    const currentUser = userStore.value.username

    const usersDataService = new DataService('users', 'username');
    const deviceDataService = new RawDataService(`device`);
    const mastersDataService = new RawDataService(`masters`);
    const assetsDataService = new RawDataService('masters/assets');
    deviceDataService.getByKey('enfyo')
    .then( objResponse => {
      Object.assign(devInfo, objResponse)
      return ;
    })
    .catch( err => notify(err.message, "error", 3000) );

    const deviceTreeStore = new CustomStore({
      key: 'id',
      load: async() => {
        try{
          let newDs = [];
          const signalList = await mastersDataService.getByKey('signals');
          const assetList = (await mastersDataService.getByKey('assets')).filter(as=> as.name!='Enfyo');
          for(const asset of assetList){
            const assetSigs = signalList.filter(s => s.assetName==asset.name);
            newDs.push({
              id: 'asset_'+asset.name, type: 'asset',
              text: asset.name, description: asset.desc })
            newDs.push({
              id: 'a_s_'+asset.name, type: 'assetSignal',
              text: 'signals', description: asset.name+'signals',
              parentId: 'asset_'+asset.name,
            });
            /*newDs.push({
              id: 'a_c_'+asset.name, type: 'assetCommand', 
              text: 'commands', description: asset.name+'commands',
              parentId: 'asset_'+asset.name,
            });*/
            newDs = [
              ...newDs, 
              ...assetSigs.map(sig => { return {
                id: 'signal_'+sig.signalId, type: 'signal',
                text: sig.name, description: sig.label,
                parentId: 'a_s_'+asset.name,
              } })
            ]
          }
          return newDs;
        }catch(err) { notify('error building assets tree: '+err.message, 'error', 4000); }
      }
    });

    

    const updateAssetTree = (e) => {
      if(e.objectType=='signal'){ // omit updates for asset changes -> no tree branch changes
        if(!e.type||!e.objectType||!e.key) throw new Error('unexpected signal update from asset-config component');
        deviceTreeStore.push([{ 
          type: e.type, key: 'signal_'+e.key, 
          data: e.data?{ id: 'signal_'+e.key, type: 'signal', text: e.data.signalName, description: e.data.description, parentId: 'a_s_'+e.data.assetName }:{},
        }]);
      }
    };

    const deviceTreeDS = new DataSource({
      store: deviceTreeStore,
      paginate: false
    });

    const devConfigView = ref('empty');
    let selectedAsset = null;
    const signalView = ref(null);
    const commandView = ref(null);
    const assetView = ref(null);
    const devViewId = ref(null);
    const treeSelectionChange = (e) => {
      e.itemData=e.data;
      const viewType = e.itemData?.type;
      let viewRef = null;
      const len = e.itemData.id.length;
      selectedAsset = null;
      switch (viewType) {
        case 'asset':
          selectedAsset = e.itemData.id?.substring(6,len);
          devViewId.value = e.itemData.id?.substring(6,len);
          viewRef = assetView.value;
          break;
        case 'assetSignal':
          devViewId.value = e.itemData.id?.substring(4,len);
          viewRef = assetView.value;
          break;
        case 'assetCommand':
          devViewId.value = e.itemData.id?.substring(4,len);
          viewRef = commandView.value;
          break;
        case 'command':
          devViewId.value = parseInt(e.itemData.id?.substring(8,len));
          viewRef = commandView.value;
          //TODO: register view for command admin
          break;
        case 'signal':
          devViewId.value = parseInt(e.itemData.id?.substring(7,len));
          viewRef = signalView.value;
          break;
      }
      devConfigView.value = viewType;
      if(viewRef){
        viewRef.loadById(devViewId.value);
      }
    }

    const signalSelection = (e) => {
      let viewRef = null;
      selectedAsset = null;
      devViewId.value = parseInt(e.data.signalId);
      viewRef = signalView.value;
         
      devConfigView.value = 'signal';
      if(viewRef){
        viewRef.loadById(devViewId.value);
      }
    }

    
    const refreshDeviceTree = async() => {
      return deviceTreeDS.reload();
    }

  
    const isShownConfirmationMessage_as = ref(false)
    const showConfirmationMessage_as = () =>{
      if(!selectedAsset) return notify('nothing to remove, no asset selected', "warning", 4000);
      isShownConfirmationMessage_as.value=true
    }
    const hideConfirmationMessage_as = () =>{
      isShownConfirmationMessage_as.value=false
    }
    const deleteSelectedAsset = async() => {
      hideConfirmationMessage_as()
      try{
        const response = await assetsDataService.remove(selectedAsset);
        if(!response.isOk) throw new Error(response.message||''); 
        notify(response.message||'deletion sent', "success", 4000);
        devConfigView.value = 'empty';
        return refreshDeviceTree();
      }
      catch(error){ 
        const message = error.data?.source_message || error.data?.message || 'unknown error processing request';
        notify(message, 'error', 4000); 
      }
    }


    

    const createOrgClick = () => {
      isCreateOrgVisible.value = true;
    }
    const isAddUserFormVisible = ref(false);
    const showAddUserForm = () => { isAddUserFormVisible.value = true; }

    const isAddAssetFormVisible = ref(false);
    const showAddAssetForm = () => { isAddAssetFormVisible.value = true; }
    const hideAddAssetForm = () => { isAddAssetFormVisible.value = false; }

    let userDS = usersDataService.dataSource
    userDS.filter(us=>us.username!='system')
    const refreshUserList = (e) => {
      // e:{ username: 'username_identity', type:'delete' } 
      userDS.reload();
      userDS.filter(us=>us.username!='system')
      if (e.type=='create'){ isAddUserFormVisible.value = false; }
    }
    
    return {
      isMyUserAdmin,
      tabs,
      orgUsersDataSource: userDS,
      createOrgClick,

      devInfo,
      currentUser,

      tabSelectedIx,
      userInviteForm,
      isCreateOrgVisible,
      newOrgInfo,

      showAddAssetForm,
      hideAddAssetForm,
      showAddUserForm,
      isAddAssetFormVisible,
      isAddUserFormVisible,
      refreshUserList,

      deviceTree,
      deviceTreeDS,
      refreshDeviceTree,
      updateAssetTree,
      treeSelectionChange,
      isShownConfirmationMessage_as,
      showConfirmationMessage_as,
      hideConfirmationMessage_as,
      deleteSelectedAsset,
      devConfigView,
      signalView,
      commandView,
      assetView,
      devViewId,

      signalSelection,

    }
  },
}
</script>
<style lang="scss">
@import url('../themes/base.scss');
.home-container {
  max-width: 1350px;
  margin: 0 auto;

.highlight {
  position: relative;
  padding: 1rem;
  margin: 1rem -0.75rem 0;
  border: solid #dee2e6;
  border-width: 1px 0 0;
}

#deviceTree {
  max-height: 1000px;
}

#circle {
      width: 10px;
      height: 10px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      margin:0ps;
      background: rgb(104, 247, 104);
    }
}
</style>
